import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemBucket extends Item {
    constructor() {
        super(definitions.ITEM_ID.BUCKET, texture("prop_wooden_bucket_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(3, 0));
    }
}